import axios from "axios";

interface IGetTourOperatorImportsCountParams {
    type: 'JIMPI' | 'TUI',
    filename: string,
    importDateFrom: string | null,
    importDateTo: string | null,
    skipped: boolean | null,
    businessError: boolean | null,
    technicalError: boolean | null,
    tenants: string[],
    dealers: string[],
}

export const getTourOperatorImportsCount = async (params: IGetTourOperatorImportsCountParams): Promise<number> => {
    const response = await axios.post('/booking/import/count', params);
    return response.data;
};

export default getTourOperatorImportsCount;